import { PHASE_HEADING_RE } from '@/features/chat/outputContract/conventions'

/**
 * The one inference rule Stage 0 evidence supports.
 *
 * Measured on live grok-4.3 output: `phase-heading` held 100% with the output
 * contract on and 0% with it off. The other proposed rules did not survive —
 * `signal-status` fired on 0% of relevant captures even with the contract on,
 * so `SignalListBlock` was cut rather than softened. See UI_STAGE0_EVIDENCE.md.
 *
 * Consumes a *range* of lines: a phase card spans its heading plus everything
 * up to the next phase heading or the next `##` section.
 *
 * @param {string[]} lines
 * @param {number} start
 * @returns {{ block: object, consumed: number } | null}
 */
export function phaseRule(lines, start) {
  if (!PHASE_HEADING_RE.test(lines[start] ?? '')) return null

  const phases = []
  let index = start

  while (index < lines.length) {
    const match = PHASE_HEADING_RE.exec(lines[index])
    if (!match) break

    let end = index + 1
    while (end < lines.length && !PHASE_HEADING_RE.test(lines[end]) && !/^##\s/.test(lines[end])) {
      end += 1
    }
    phases.push({
      index: Number(match[1]),
      name: match[2].trim(),
      timeframe: match[3].trim(),
      body: lines.slice(index + 1, end).join('\n').trim(),
    })
    index = end
  }

  // A lone phase heading is more likely a coincidence than a plan, and a
  // one-card "phase list" reads worse than the markdown it replaced.
  if (phases.length < 2) return null

  return { block: { type: 'phaseList', phases }, consumed: index - start }
}
